// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
// 引入element UI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
// 引入路由
import router from "./router";
// 引入状态管理
import store from "./vuex/store";
// 引入icon
import "./assets/icon/iconfont.css";
// 引入导出插件
import JsonExcel from "vue-json-excel";

// 引入echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

import axios from "axios";
import {getCookie} from './utils/util';

// 创建axios实例
const axiosInstance = axios.create({
  
});

// 请求拦截器
axiosInstance.interceptors.request.use(config => {
  var user_id = getCookie('user_id');
  var role_id = getCookie('role_id');
  var salesman_id = getCookie('salesman_id');
  var app_id = getCookie('app_id');
  var channel_id = getCookie('channel_id');
  var info_show_type = getCookie('info_show_type');
  var write_type = getCookie('write_type');
  // 可以在这里动态设置请求头
  config.headers['user-id'] = user_id;
  config.headers['role-id'] = role_id;
  config.headers['salesman-id'] = salesman_id;
  config.headers['app-id'] = app_id;
  config.headers['channel-id'] = channel_id;
  config.headers['info-show-type'] = info_show_type;
  config.headers['write-type'] = write_type;
  return config;
}, error => {
  // 处理请求错误
  return Promise.reject(error);
});
Vue.prototype.$axios = axiosInstance;

Vue.config.productionTip = false;
Vue.component("downloadExcel", JsonExcel);

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from "./utils/util";


Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key]);
});

// 路由拦截器
router.beforeEach((to, from, next) => {
  if (to.matched.length != 0) {
    if (to.meta.requireAuth) {
      // 判断该路由是否需要登录权限
      if (Boolean(localStorage.getItem("userInfo"))) {
        // 通过vuex state获取当前的user是否存在
        next();
      } else {
        next({
          path: "/Login",
          query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    } else {
      if (Boolean(localStorage.getItem("userInfo"))) {
        // 判断是否登录
        if (to.path != "/" && to.path != "/Login") {
          //判断是否要跳到登录界面
          next();
        } else {
          /**
           * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
           */
          next({
            path: "/PageConfig"
          });
        }
      } else {
        next();
      }
    }
  } else {
    next({
      path: "/Index",
      query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    });
  }
});

// 全局按钮权限
import hasMenu from "@/utils/hasMenu";
Vue.directive('hasMenu', hasMenu)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store, //使用store vuex状态管理
  components: { App },
  template: "<App/>",
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }
});



// WEBPACK FOOTER //
// ./src/main.js